var _a;
export var TextButtonSize;
(function (TextButtonSize) {
    TextButtonSize[TextButtonSize["Small"] = 0] = "Small";
    TextButtonSize[TextButtonSize["Medium"] = 1] = "Medium";
})(TextButtonSize || (TextButtonSize = {}));
var TextButtonSizeMap = (_a = {},
    _a[TextButtonSize.Small] = 'text-xs',
    _a[TextButtonSize.Medium] = 'text-sm',
    _a);
export function getTextButtonSizeClass(size) {
    return TextButtonSizeMap[size];
}
